module.exports = __webpack_public_path__ + "static/media/3.d67f703.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/3.wav
// module id = UYWm
// module chunks = 0